<template>
    <form class="vx-col w-full mx-auto d-theme-dark-bg" @submit="authenticate2fa">
        <div class="p-8">
            <div class="vx-card__title mb-8">
                <h4 class="mb-4">Enter your Code to continue.</h4>
            </div>
            <vs-input icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="Code" v-model="code" class="w-full mb-6"/>

            <div class="flex justify-between flex-wrap">
                <vs-button class="ml-2" @click="authenticate2fa">Unlock</vs-button>
            </div>

        </div>
    </form>
</template>

<script>
export default {
    name: 'ht-staff-2fa',
    data () {
        return {
            code: ''
        }
    },
    props: ['token'],
    methods: {
        authenticate2fa: function(e) {
            e.preventDefault()
            const body = {
                code: this.code,
                api_token: this.token
            }
            this.$http.post('https://staffapi.hebtrek.nl/v1/2fa', body).then((response) => {
                console.log(response)
                if(response.data.token) {
                    localStorage.setItem('stafftoken', JSON.stringify(response.data.token))
                    localStorage.setItem('user', JSON.stringify(response.data.user))
                    localStorage.setItem('color', JSON.stringify(response.data.user.color))
                    this.$router.push('/');
                }
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            });
        }
    }
}
</script>
